module.exports = __webpack_public_path__ + "media/country_flags/uz-9f39576a.png";